import React from "react";
import { Footer } from "./Footer";
import { NavBar } from "./NavBar";
import { OnboardingRedirect } from "../components/shared/ui";
import SheetGround from "../components/shared/ui/SheetGround";
import CookieConsentBanner from "../components/shared/ui/CookieConsentBanner";
import { LoginModalProvider, useLoginModal } from "../context/LoginModalContext";
import { AuthModal } from "../components/ui/AuthModal";
import { LoginModalContent, DIALOG_TITLE_ID } from "../components/sections/LoginModalContent";
import { RegisterModalContent } from "../components/sections/RegisterModalContent";

const AuthModals: React.FC = () => {
  const { activeModal, closeLoginModal, closeRegisterModal } = useLoginModal();

  return (
    <>
      <AuthModal
        isOpen={activeModal === "login"}
        onClose={closeLoginModal}
        size="sm"
        labelledBy={DIALOG_TITLE_ID}
      >
        <LoginModalContent />
      </AuthModal>
      <AuthModal
        isOpen={activeModal === "register"}
        onClose={closeRegisterModal}
        size="md"
        labelledBy={DIALOG_TITLE_ID}
      >
        <RegisterModalContent />
      </AuthModal>
    </>
  );
};

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <LoginModalProvider>
      <div className="max-w-screen">
        <OnboardingRedirect />
        <NavBar />
        {/* Main is the sheet, not a panel the sheet is laid on.

            It was painted --aca-paper (#eeeae0, the superseded beige) while
            min-h-screen guaranteed it is at least a viewport tall, so every
            folio page shorter than the viewport - /contact is the clearest -
            ended in a band of the old theme between the sheet and the
            footer. Ruling main rather than only recolouring it means the
            grid continues too: main and the page's own SheetGround share a
            top-left origin and the same 10/50 pitch, so the tiling lands on
            the same cells and there is no seam to find.

            Pages still on the old palette paint their own ground over this,
            so they are unaffected. Body was moved onto the same ground
            earlier for the overscroll flash; this is the last surface. */}
        <SheetGround as="main" className="max-w-screen min-h-screen">{children}</SheetGround>
        <Footer />
        <CookieConsentBanner />
        <AuthModals />
      </div>
    </LoginModalProvider>
  );
};

export default Layout;
